/** @jsxImportSource @emotion/react */

import React, { useRef } from "react";
import { ModalProps } from "./Modal.d";

import { CalciteModal } from "@esri/calcite-components-react";
import "@esri/calcite-components/dist/components/calcite-modal";
import tw from "twin.macro";

const Modal: React.FC<ModalProps> = ({
  title,
  content,
  isOpen,
  onClose,
  disableCloseButton = false,
  kind = "brand",
  primary,
  secondary,
  outsideCloseDisabled,
  isFullScreen = undefined,
  width = "m",
  scale = "m",
}) => {
  const calciteModal = useRef<HTMLCalciteModalElement>(null);

  return (
    <CalciteModal
      kind={kind}
      open={isOpen}
      outsideCloseDisabled={outsideCloseDisabled}
      ref={calciteModal}
      aria-labelledby="modal-title"
      onCalciteModalClose={onClose}
      closeButtonDisabled={disableCloseButton}
      scale={scale}
      fullscreen={isFullScreen}
    >
      <h3 slot="header" id="modal-title">
        {title}
      </h3>
      <div slot="content" css={[tw``]}>
        {content}
      </div>

      {secondary && <div slot="secondary">{secondary}</div>}
      {primary && <div slot="primary">{primary}</div>}
    </CalciteModal>
  );
};

export default Modal;
